import React from 'react';

interface IconProps {
  type:
    | 'address-suggestion'
    | 'agent'
    | 'home'
    | 'inspiration'
    | 'listing'
    | 'price-estimation'
    | 'school'
    | 'webhook'
    | 'property-enrichment'
    | 'property-package'
    | 'property-radar';
}

function Icon(props: IconProps): React.ReactElement {
  return (
    <img
      src={`/assets/illustrations/${props.type}.svg`}
      alt={props.type}
      width={77}
      height={66}
    />
  );
}

export default Icon;
